Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentHeaderView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content_header']

  initialize: (options = {}) ->
    @model = options.model
    @subtypeTranslations = new Monitoring.Views.SocialContents.Filters.SubTypeTranslations()

  innerTemplateRoute: ->
    specificities = [
      [@model.type(), @model.subType()],
      [@model.groupType(), @model.type(), @model.subType()],
      [@model.groupType(), @model.type()],
      [@model.groupType()]
    ]
    templateRoutes = _.map(specificities, (s) ->
      "backbone/templates/monitoring/social_contents/#{s.join('/')}/social_content_header"
    )
    selectedTemplateRoute = _.find(templateRoutes, (tr) -> JST[tr])
    selectedTemplateRoute

  render: ->
    if @innerTemplateRoute()
      @template = JST[@innerTemplateRoute()]
    @remove() unless @model.hasUser()
    @$el.html @template(@templateOptions())
    @_renderAvatar()
    this

  normalizeSubType: ->
    return @_translateSubType() if @_shouldTranslate()
    _.str.humanize(@model.subType())

  templateOptions: ->
    type: @model.type()
    subtype: @normalizeSubType()
    retweet_number: @model.retweet_count?()
    icons: @_icons()
    name: if @_isInstagramMessage() then @model.username() else @model.name()
    socialNetworkName: @model.socialNetworkName()
    socialNetworkName: @model._getContent().socialNetworkName() if @_isInstagramListening()
    username: @model.username?()
    source: @model.contentUrl() if @model.hasContentUrl()
    showProfile: @model.hasProfile()
    hashtag: @model._getContent().hashtagName() if @_isInstagramListening()
    model: @model

  _icons: ->
    iconPath = window.icon_for @model.subType()
    return null unless iconPath
    {

      regular: window.image_path(iconPath + '.png')
      twoX: window.image_path(iconPath + '@2x.png')
      threeX: window.image_path(iconPath + '@3x.png')
    }

  _renderAvatar: ->
    @avatarView = if @model.type() == 'twitter' then @_twitterAvatarView() else @_genericAvatarView()
    @$el.find('.sc-avatar').html @avatarView.render()

  _twitterAvatarView: ->
    new Monitoring.Views.TwitterAvatarView
      socialContent: @model

  _genericAvatarView: ->
    new Monitoring.Views.GenericAvatarView
      socialContent: @model

  _isInstagramListening: ->
    @model.type() == 'instagram' and (@model.subType() == 'instagram_listening_media' || @model.origin() == 'instagram_listening_media')

  _isGoogleMyBusiness: ->
    @model.type() == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent.TYPE

  _isInstagramMessage: ->
    subtype = Models.InstagramMessageContent.SUB_TYPE
    origin = Models.InstagramMessageContent.ORIGIN
    @model.subType() == subtype && @model._getContent().getOrigin() == origin

  _shouldTranslate: ->
    @_isGoogleMyBusiness() || @_isInstagramMessage()

  _translateSubType: ->
    return @subtypeTranslations.getTranslation(@model.subType())
